// extracted by mini-css-extract-plugin
export var externalLink = "_9l-0";
export var internalLinkLabel = "_9l-1";